import { MessageCircle, Mail, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E5DEC9] bg-[#FDFBF7] pb-10 pt-20"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <button
          data-testid="footer-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="block w-full text-left font-serif text-[13vw] font-bold uppercase leading-none tracking-[0.06em] text-[#8B0000] transition-colors duration-500 hover:text-[#6D0000] lg:text-[10rem]"
        >
          MRVEER.IN
        </button>

        <div className="mt-14 flex flex-col items-start justify-between gap-8 border-t border-[#E5DEC9] pt-8 sm:flex-row sm:items-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#686152]">
            © 2026 mrveer.in · Groom · Family · Personal Styling
          </p>
          <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-10">
            <a
              data-testid="footer-email-btn"
              href="mailto:mrveer.in7@gmail.com"
              className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#686152] transition-colors hover:text-[#141414]"
            >
              <Mail size={14} />
              mrveer.in7@gmail.com
            </a>
            <a
              data-testid="footer-instagram-btn"
              href="https://instagram.com/mrveer.in"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.25em] text-[#686152] transition-colors hover:text-[#141414]"
            >
              <Instagram size={14} />
              @mrveer.in
            </a>
            <a
              data-testid="footer-whatsapp-btn"
              href="https://wa.me/918801387013?text=Hello%20Manvir%2C%20I%20want%20to%20book%20a%20styling%20appointment."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.25em] text-[#C5A059] transition-colors hover:text-[#141414]"
            >
              <MessageCircle size={14} />
              +91 88013 87013
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
